import { isSlideComponentCharacter, Question } from '@/types/slide';

export function isCorrectnessDeterminable(question: Question): boolean {
    switch (question.type) {
        case 'character': {
            if (!isSlideComponentCharacter(question)) {
                return true;
            }

            if (question.content.gameType === 'Writing' && question.content.normalMode) {
                return true;
            }

            if (question.content.gameType === 'OneCard' || question.content.gameType === 'TwoCards') {
                return true;
            }

            return false;
        }
        case 'drawing':
            return false;
        case 'characterCards':
            return true;
        default:
            return true;
    }
}

export function getScore(question: Question): number {
    if (question.answers.length === 0) return 0;

    return isCorrectnessDeterminable(question) ? (question.answers[0]?.correct ? 1 : 0) : 1;
}
